import * as colorStyles from "../PricingPlan.module.scss";
import * as styles from "./Price.module.scss";
import * as React from "react";

let classNames = require("classnames");

interface PriceProps {
  period: "monthly" | "yearly";
  userCurrency: { name: string; label: string };
  theme?: "light" | "dark";
  dynamicPrice?: number;
  children?: React.ReactNode;
}

export const symbolForPlanCurrency = {
  USD: "$",
  AUD: "$",
  GBP: "£",
  EUR: "€",
};

const payCycleLabel = { monthly: "month", yearly: "year" };

const formatPrice = (price?: number): string | undefined => {
  if (typeof price !== "number" || Number.isNaN(price)) {
    return undefined;
  }
  const roundedPrice = Math.round(price * 100) / 100;
  const isInteger = Number.isInteger(roundedPrice);

  return roundedPrice.toLocaleString("en-US", {
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: isInteger ? 0 : 2,
  });
};

export const Price = ({ period, userCurrency, theme, dynamicPrice, children }: PriceProps): JSX.Element => {
  const isYearly = period === "yearly";

  let payCycleStyles = colorStyles.planLightPayCycle;
  if (theme == "dark") {
    payCycleStyles = colorStyles.planDarkPayCycle;
  }

  const currencySymbol = symbolForPlanCurrency[userCurrency.label];
  const primaryPrice = typeof dynamicPrice === "number" ? dynamicPrice * (isYearly ? 12 : 1) : undefined;
  const formattedPrimaryPrice = formatPrice(primaryPrice) ?? "";
  const formattedMonthlyPrice = isYearly ? formatPrice(dynamicPrice) : undefined;

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={styles.priceLine}>
          <span
            className={classNames(styles.price, {
              [colorStyles.planDarkPrice]: theme == "dark",
            })}
          >
            {currencySymbol}
            {formattedPrimaryPrice}
          </span>

          <span className={classNames(styles.payCycle, payCycleStyles)}>/{payCycleLabel[period]}</span>
        </div>
        {isYearly && formattedMonthlyPrice && (
          <div className={classNames(styles.yearlyMonthlyPrice, payCycleStyles)}>
            ({currencySymbol}
            {formattedMonthlyPrice}/month)
          </div>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
};
